import React, { useRef, useState, useEffect } from 'react';

const TimeList = ({ selectedTime, onTimeSelect }) => {
  const timeListRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const timeSlots = [
    { time: '09:00', period: 'AM' },
    { time: '09:30', period: 'AM' },
    { time: '10:00', period: 'AM' },
    { time: '10:30', period: 'AM' },
    { time: '11:00', period: 'AM' },
    { time: '11:30', period: 'AM' },
    { time: '12:00', period: 'PM' },
    { time: '12:30', period: 'PM' },
    { time: '13:00', period: 'PM' },
    { time: '13:30', period: 'PM' },
    { time: '14:00', period: 'PM' },
    { time: '14:30', period: 'PM' },
    { time: '15:00', period: 'PM' },
    { time: '15:30', period: 'PM' },
    { time: '16:00', period: 'PM' },
    { time: '16:30', period: 'PM' },
    { time: '17:00', period: 'PM' },
    { time: '17:30', period: 'PM' },
    { time: '18:00', period: 'PM' },
    { time: '18:30', period: 'PM' },
    { time: '19:00', period: 'PM' },
    { time: '19:30', period: 'PM' },
    { time: '20:00', period: 'PM' }
  ];

  useEffect(() => {
    const handleMouseUp = () => {
      setIsDragging(false);
      if (timeListRef.current) {
        timeListRef.current.style.cursor = 'grab';
      }
    };

    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX);
    setScrollLeft(timeListRef.current.scrollLeft);
    timeListRef.current.style.cursor = 'grabbing';
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const x = e.pageX - startX;
    timeListRef.current.scrollLeft = scrollLeft - x;
  };

  const handleTimeClick = (time) => {
    onTimeSelect(time);
  };

  return (
    <div className="select-timelist">
      <label>Select Time</label>
      <ul
        className="select-time"
        id="timeList"
        ref={timeListRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
      >
        {timeSlots.map((slot, index) => (
          <li
            key={index}
            className={selectedTime === slot.time ? 'time-active' : ''}
            onClick={() => handleTimeClick(slot.time)}
          >
            <span>{slot.time}</span> <span>{slot.period}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TimeList;